import styled, { css } from 'styled-components'
import { Container } from 'src/components/common/Container'
import { ellip, layoutMaxSize } from 'src/styles/mixin'
import { Typography } from 'src/components/common/Typography'
import {
  Noto_body1_r16,
  Noto_body2_r14,
  Noto_body3_r12,
  Noto_subheading_b18,
} from 'src/styles/fonts/NotoSansKrFonts'
import { Roboto_num1_b18, Roboto_num1_b20, Roboto_num3_r14 } from 'src/styles/fonts/RobotoFonts'
import { Divider, SmallDivider } from 'src/components/common/Divider'
import React from 'react'
import RenderIf from 'src/components/common/RenderIf'
import LazyImage from 'src/components/common/LazyImage'
import Skeleton from 'react-loading-skeleton'
import { GiftHotDealPageProps } from 'src/pages/GiftHotDealPage/index'
import Button, { ButtonOption3 } from 'src/components/common/Button'
import HotDealPreceed from 'src/pages/MainPage/_components/FloatItemHotDealCoupon/HotDealPreceed'
import usePageNav from 'src/hooks/usePageNav.hook'
import GiftHeader from 'src/components/layout/GiftHeader/view'
import hotdeal_soldout_tag from 'src/assets/images/main/hotdeal_soldout_tag.png'

const GiftHotDealPageView = ({
  hotDealInProgressList,
  hotDealInComingList,
  bannerItem,
  openService,
}: GiftHotDealPageProps) => {
  const { giftHotDealDetailPageNav } = usePageNav()

  return (
    <S.Background>
      <S.GiftHotDealWrap $option="flex_column">
        <GiftHeader title="나도 선물하기" isBackBtn={true} />
        {/*배너*/}
        <LazyImage
          src={bannerItem?.Image}
          alt="배너 이미지"
          style={S.GiftCardBanner()}
          onClick={() => window.open(bannerItem?.URL, '_blank')}
        />
        <S.GiftHotDeal.Container $option="flex_column">
          {/*진행 중 핫딜*/}
          <S.GiftHotDeal.InProgress.Container $option="flex_column" $row_gap="6px">
            <Typography $fontStyle={Noto_subheading_b18} $color="var(--black-90)">
              진행 중 핫딜
            </Typography>
            <RenderIf when={hotDealInProgressList?.length === 0}>
              <S.GiftHotDeal.EmptyCouponLists $option="flex_column">
                <Typography $fontStyle={Noto_body1_r16} $color="var(--black-30)">
                  상품을 준비중입니다.
                </Typography>
              </S.GiftHotDeal.EmptyCouponLists>
            </RenderIf>
            <RenderIf when={hotDealInProgressList?.length !== 0}>
              <Container $option="flex_column" $row_gap="26px">
                {hotDealInProgressList?.map(
                  (
                    {
                      CouponIdx,
                      CouponImage,
                      DiscountRate,
                      RegularPrice,
                      SalePrice,
                      CouponName,
                      EndDT,
                      SellFlag,
                    },
                    i_i,
                  ) => {
                    return (
                      <S.GiftHotDeal.InProgress.Items.Card
                        $option="flex_column"
                        key={i_i}
                        onClick={() => SellFlag !== 2 && giftHotDealDetailPageNav(CouponIdx)}
                      >
                        <LazyImage
                          src={CouponImage}
                          alt="쿠폰 이미지"
                          style={S.GiftHotDeal.InProgress.Items.Image(SellFlag === 2)}
                        />
                        <RenderIf when={SellFlag === 0}>
                          <HotDealPreceed
                            colorOption="black"
                            EndDT={EndDT}
                            position={{ t: '-45px', l: '8px' }}
                          />
                        </RenderIf>
                        <RenderIf when={SellFlag === 2}>
                          <S.GiftHotDeal.InProgress.SoldOutContents.Container $option="flex_column">
                            <S.GiftHotDeal.InProgress.SoldOutContents.Fence />
                          </S.GiftHotDeal.InProgress.SoldOutContents.Container>
                        </RenderIf>
                        <RenderIf when={!!SalePrice}>
                          <S.GiftHotDeal.InProgress.Items.CouponName
                            $fontStyle={Noto_body2_r14}
                            $color="var(--black-90)"
                          >
                            {CouponName}
                          </S.GiftHotDeal.InProgress.Items.CouponName>
                          <S.GiftHotDeal.InProgress.Items.PriceInfo
                            $option="flex_row"
                            $column_gap="4px"
                          >
                            <S.GiftHotDeal.InProgress.Items.DiscountRate
                              $fontStyle={Roboto_num1_b20}
                              $color="#FC2600"
                            >
                              {Math.floor((DiscountRate as number) * 10) / 10}%
                            </S.GiftHotDeal.InProgress.Items.DiscountRate>
                            <S.GiftHotDeal.InProgress.Items.SalePrice
                              $fontStyle={Roboto_num1_b20}
                              $color="var(--black-90)"
                              as={!!SalePrice ? Typography : Skeleton}
                            >
                              {SalePrice?.toLocaleString()}원
                            </S.GiftHotDeal.InProgress.Items.SalePrice>
                            <S.GiftHotDeal.InProgress.Items.RegularPrice
                              $fontStyle={Roboto_num3_r14}
                              $color="var(--black-30)"
                            >
                              {RegularPrice?.toLocaleString()}원
                            </S.GiftHotDeal.InProgress.Items.RegularPrice>
                          </S.GiftHotDeal.InProgress.Items.PriceInfo>
                        </RenderIf>
                        <RenderIf when={!SalePrice}>
                          <Skeleton count={2} style={{ marginBottom: '5px' }} />
                        </RenderIf>
                      </S.GiftHotDeal.InProgress.Items.Card>
                    )
                  },
                )}
              </Container>
            </RenderIf>
          </S.GiftHotDeal.InProgress.Container>
        </S.GiftHotDeal.Container>
        <S.DividerWrap>
          <Divider />
        </S.DividerWrap>
        <S.GiftHotDeal.Container $isLast={true}>
          {/*진행 예정 핫딜*/}
          <RenderIf when={hotDealInComingList?.length !== 0}>
            <S.GiftHotDeal.InComing.Container $option="flex_column" $row_gap="14px">
              <S.GiftHotDeal.Title.Text $fontStyle={Noto_subheading_b18}>
                ⏳오픈 예정 핫딜
              </S.GiftHotDeal.Title.Text>
              <Container $option="flex_column" $row_gap="14px">
                {hotDealInComingList?.map(({ CouponName, CouponImage, DiscountRate, StartDT }) => (
                  <S.GiftHotDeal.InComing.Items.Card
                    $option="flex_row"
                    $column_gap="10px"
                    key={CouponName}
                  >
                    <S.GiftHotDeal.InComing.Items.ImageContainer>
                      <S.GiftHotDeal.InComing.Items.ImageCover>
                        <S.GiftHotDeal.InComing.Items.ImageText>
                          Coming
                          <br />
                          Soon
                        </S.GiftHotDeal.InComing.Items.ImageText>
                      </S.GiftHotDeal.InComing.Items.ImageCover>
                      <LazyImage
                        src={CouponImage}
                        alt="쿠폰 이미지"
                        style={S.GiftHotDeal.InComing.Items.Image}
                      />
                    </S.GiftHotDeal.InComing.Items.ImageContainer>
                    <S.GiftHotDeal.InComing.Items.CouponInfo $option="flex_column" $row_gap="6px">
                      <Typography $fontStyle={Roboto_num1_b18} $color="var(--black-90)">
                        <Typography $color="#FC2600">
                          {Math.floor((DiscountRate as number) * 10) / 10}%
                        </Typography>{' '}
                        예정
                      </Typography>
                      <S.GiftHotDeal.InComing.Items.CouponName
                        $fontStyle={Noto_body3_r12}
                        $color="var(--black-50)"
                      >
                        {CouponName}
                      </S.GiftHotDeal.InComing.Items.CouponName>
                    </S.GiftHotDeal.InComing.Items.CouponInfo>
                  </S.GiftHotDeal.InComing.Items.Card>
                ))}
              </Container>
            </S.GiftHotDeal.InComing.Container>
          </RenderIf>
        </S.GiftHotDeal.Container>
        <SmallDivider />
        {/*하단 고정 버튼*/}
        <S.GiftHotDealBottomContainer $option="flex_column">
          <Button option={ButtonOption3('active')} onClickFn={openService}>
            핫딜 구매하러 가기
          </Button>
        </S.GiftHotDealBottomContainer>
      </S.GiftHotDealWrap>
    </S.Background>
  )
}
export default GiftHotDealPageView

const S = {
  Background: styled(Container)`
    display: flex;
    justify-content: center;
    width: 100%;
    background-color: var(--black-2);
  `,
  GiftHotDealWrap: styled(Container)`
    ${layoutMaxSize};
    margin-top: 50px;
    align-items: center;
    padding-bottom: 68px;
    min-width: 320px;
    background-color: var(--white);
  `,
  GiftCardBanner: () => css``,
  GiftHotDeal: {
    Container: styled(Container)<{ $isLast?: boolean }>`
      max-width: 360px;
      width: 100%;
      font-size: 30px;
      font-weight: bold;
      align-items: center;
      margin: 0 auto;
      padding: 30px 20px;
    `,
    EmptyCouponLists: styled(Container)`
      justify-content: center;
      text-align: center;
      padding: 100px 0;
      flex: 1;
    `,
    EmptyIcon: styled.img``,
    Title: {
      Container: styled(Container)`
        align-items: center;
      `,
      Text: styled(Typography)``,
      Point: styled(Typography)`
        display: flex;
        border-radius: 4px;
        background: linear-gradient(180deg, #6001fc 0%, #0271fe 100%);
        padding: 4px 6px;
        line-height: 12px;
        width: fit-content;
        height: fit-content;
      `,
    },
    InProgress: {
      Container: styled(Container)``,
      Items: {
        Card: styled(Container)`
          position: relative;
          cursor: pointer;
        `,
        PriceInfo: styled(Container)`
          align-items: center;
        `,
        Image: (disabled: boolean) => css`
          width: 100%;
          height: 220px;
          border-radius: 20px;
          padding: 0.5px;
          margin-bottom: 12px;
          img {
            border: 1px solid rgba(0, 0, 0, 0.01);
            width: 100%;
            height: 220px;
            object-fit: cover;
            object-position: center;
            border-radius: 20px;
          }
          ${disabled &&
          css`
            cursor: default;
          `}
        `,
        DiscountRate: styled(Typography)``,
        SalePrice: styled(Typography)``,
        RegularPrice: styled(Typography)`
          text-decoration: line-through;
        `,
        CouponName: styled(Typography)`
          margin-bottom: 4px;
          text-align: left;
        `,
      },
      SoldOutContents: {
        Container: styled(Container)`
          position: absolute;
          height: 220px;
          width: 100%;
          justify-content: center;
          pointer-events: none;
        `,
        Fence: styled.section`
          display: flex;
          background: linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.7) 100%);
          border-radius: 20px;
          &:after {
            content: '';
            width: 100%;
            height: 220px;
            background: url(${hotdeal_soldout_tag}) no-repeat center;
            background-size: 170px 170px;
          }
        `,
      },
    },
    InComing: {
      Container: styled(Container)``,
      Items: {
        Card: styled(Container)`
          height: 120px;
        `,
        CouponInfo: styled(Container)`
          height: 100%;
          justify-content: center;
        `,
        ImageContainer: styled(Container)`
          position: relative;
          min-width: 120px;
          width: auto;
          height: 100%;
          border-radius: 14px;
          overflow: hidden;

          &:hover {
            transform: scale(1.05);
          }
        `,
        ImageCover: styled(Container)`
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          min-width: 120px;
          width: auto;
          height: 100%;
          background: rgba(0, 0, 0, 0.7);
          z-index: 1;
        `,
        ImageText: styled.span`
          color: var(--white);
          font-family: RobotoBold, sans-serif;
          font-size: 13px;
          font-weight: 900;
          text-align: center;
        `,
        Image: css`
          min-width: 120px;
          width: auto;
          height: 100%;
        `,
        CouponName: styled(Typography)`
          ${ellip('line2')};
        `,
      },
    },
  },
  GiftHotDealBottomContainer: styled(Container)`
    ${layoutMaxSize};
    min-width: 320px;
    padding: 10px;
    position: fixed;
    bottom: 0;
    z-index: 2;
    background-color: var(--white);
  `,
  DividerWrap: styled.div`
    padding: 10px 0;
    width: 100%;
  `,
}
